import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Modal, Button, Icon } from "../..";

/**
 * Table Rich Popup
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TableRichModal = function TableRichModal(props) {
  var isVisible = props.isVisible,
    comp = props.comp,
    item = props.item,
    onSave = props.onSave,
    mountNode = props.mountNode,
    closeModal = props.closeModal,
    onOpen = props.onOpen,
    _onClose = props.onClose,
    setUpdating = props.setUpdating,
    labelColonne = props.labelColonne,
    indexColonne = props.indexColonne;
  return /*#__PURE__*/_jsxs(Modal, Object.assign({}, comp.modalProps, {
    on: "click",
    pinned: true,
    size: comp.size || 'large',
    mountNode: mountNode,
    flowing: true,
    closeOnDimmerClick: false,
    closeOnEscape: false,
    onClose: function onClose() {
      return _onClose(true);
    },
    trigger: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return onOpen();
      },
      className: "iconActions",
      inline: true,
      icon: comp.icon,
      size: "small",
      style: {
        visibility: !_.isNil(isVisible) && isVisible() ? 'visible' : 'hidden'
      }
    }),
    children: [!_.isNil(comp.title) ? /*#__PURE__*/_jsx(Modal.Header, {
      children: /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsxs(Grid.Row, {
          children: [/*#__PURE__*/_jsx(Grid.Column, {
            width: 15,
            children: comp.title
          }), /*#__PURE__*/_jsx(Grid.Column, {
            children: /*#__PURE__*/_jsx(Icon, {
              name: "close",
              onClick: function onClick() {
                return closeModal(true);
              }
            })
          })]
        })
      })
    }, "header") : '', /*#__PURE__*/_jsx(comp.component, Object.assign({}, item.props, {
      setUpdating: setUpdating,
      closeModal: closeModal,
      onSave: onSave,
      labelColonne: labelColonne,
      indexColonne: indexColonne
    }))]
  }));
};
TableRichModal.handledProps = ["closeModal", "closePopup", "comp", "indexColonne", "isVisible", "item", "labelColonne", "mountNode", "onClose", "onOpen", "onSave", "setUpdating"];
TableRichModal.propTypes = {
  isVisible: PropTypes.func,
  mountNode: PropTypes.node,
  onSave: PropTypes.func,
  comp: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  item: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  closePopup: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  closeModal: PropTypes.func,
  setUpdating: PropTypes.func,
  labelColonne: PropTypes.string,
  indexColonne: PropTypes.number
};
TableRichModal.defaultProps = {
  isVisible: null,
  onSave: null,
  // mountNode: null,
  comp: {},
  item: {},
  closePopup: null,
  onOpen: null,
  onClose: null,
  closeModal: PropTypes.func,
  setUpdating: PropTypes.func,
  labelColonne: '',
  indexColonne: 0
};
export default TableRichModal;